export default __webpack_public_path__ + "static/media/feraye3.135cf539.jpg";